@if (loaderType !== 'box') {
  @for (item of arrLoader; track item) {
    <div class="mt-ghost-loader-wrapper">
      <div class="mt-ghost-loader-item">
        @if (loaderType === 'timeline') {
          <div class="animated-background m-timeline-loader-height">
            <!-- for timeline loader -->
            <div class="background-masker header-top"></div>
            <div class="background-masker header-left"></div>
            <div class="background-masker header-right"></div>
            <div class="background-masker header-bottom"></div>
            <div class="background-masker subheader-left"></div>
            <div class="background-masker subheader-right"></div>
            <div class="background-masker subheader-bottom"></div>
          </div>
        }
        <!-- for default loader -->
        @if (loaderType == 'default') {
          <div class="animated-background second-line-animated"></div>
          <div class="animated-background third-line-animated"></div>
        }
      </div>
    </div>
  }
}

<!-- for only box loader -->
@if (loaderType === 'box') {
  <div class="m-box-loader-wrapper" [ngClass]="boxPerRow">
    @for (item of arrLoader; track item) {
      <div class="mt-loader-box mt-shine" [style.height]="height" [style.width]="width"></div>
    }
  </div>
}
<!-- ./end -->
